import React from 'react';

class Legend extends React.Component {
  shouldComponentUpdate(newProps) {
    const { props } = this;

    if (newProps.legend != props.legend) {
      return true;
    }

    if (newProps.data != props.data) {
      return true;
    }

    return false;
  }

  render() {
    const { data, legend } = this.props;

    if (!legend) {
      return null;
    }

    const onHover = data.length > 1 ? this.onHover : () => {};

    const items = data.map((item, idx) => {
      const { colour = 'gray', label = '' } = item;
      const onMouseOver = onHover.bind(this, false, idx, true);
      const onMouseOut = onHover.bind(this, false, idx, false);

      return (
        <li
          className="legend-item"
          key={`legend-item-${idx}`}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <svg className="colour-tab">
            <rect fill={colour} x={0} y={0} width={30} height={30} />
          </svg>
          <span>{label}</span>
        </li>
      );
    });

    return (
      <div className="bz-column bz-col-50 legend">
        <div className="legend-container">
          <ul>{items}</ul>
        </div>
      </div>
    );
  }

  onHover(hasLabel, idx, value) {
    this.props.onHover(hasLabel, idx, value);
  }
}

Legend.defaultProps = {
  data: [],
  legend: false,
  onHover: () => {}
};

export default Legend;
